type TestCaseRating = TestRequestRaw.Schemas.TestCaseRating;

export const RATING_DICTIONARY: { [R in TestCaseRating]: string } = {
  FAILED: "Failed",
  PASSED: "Passed",
  PARTIALLY_PASSED: "Partially Passed",
  NOT_RATED: "Not Rated",
};

export default TestCaseRating;
